export const LOAD_WALLETS_LIST = 'LOAD_WALLETS_LIST';
export const LOAD_AML_REPORTS = 'LOAD_AML_REPORTS';
export const CREATE_WALLET = 'CREATE_WALLET';
export const SET_WALLET_FROZEN = 'SET_WALLET_FROZEN';
export const SET_WALLET_DESCRIPTION = 'SET_WALLET_DESCRIPTION';
export const RESET_WALLETS = 'RESET_WALLETS';
